// React-Query hook для Mini-sprint 6-action-plan.
//
// GET /api/v1/biomarkers/{code}/action-plan — синхронный (без polling/generating,
// в отличие от insights). Status: ready | disabled | no_data | no_advice.
// staleTime 5 минут — cache hit при повторном открытии карточки биомаркера.

import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';
import type { ActionPlanResponse, ApiError } from '@/api/types';

export type UseBiomarkerActionPlanOptions = {
  enabled?: boolean;
};

export function biomarkerActionPlanQueryOptions(
  code: string,
  options: UseBiomarkerActionPlanOptions = {},
): UseQueryOptions<ActionPlanResponse, AxiosError<ApiError>> {
  const { enabled = true } = options;
  return {
    queryKey: queryKeys.biomarkerActionPlan(code),
    queryFn: async () => {
      const { data } = await api.get<ActionPlanResponse>(
        `/biomarkers/${encodeURIComponent(code)}/action-plan`,
      );
      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  };
}

export function useBiomarkerActionPlan(
  code: string,
  options: UseBiomarkerActionPlanOptions = {},
): UseQueryResult<ActionPlanResponse, AxiosError<ApiError>> {
  return useQuery(biomarkerActionPlanQueryOptions(code, options));
}
